import { HiOutlineMail, HiOutlineArrowRight } from 'react-icons/hi';
import { FiLinkedin, FiGithub } from 'react-icons/fi';
import { profile } from '../data/content';
import Reveal from './Reveal';
import './Contact.css';

export default function Contact() {
  const year = new Date().getFullYear();

  return (
    <footer id="contact" className="contact">
      <div className="container">
        <Reveal className="contact__card card">
          <div className="contact__glow" aria-hidden />

          <span className="contact__eyebrow mono">Get in touch</span>
          <h2 className="contact__title">
            Let's build something{' '}
            <span className="gradient-text">great together</span>.
          </h2>
          <p className="contact__text">
            I'm currently open to new opportunities and interesting projects.
            Whether you have a question, a role, or just want to say hi — my
            inbox is always open.
          </p>

          <a className="btn btn-primary contact__cta" href={`mailto:${profile.email}`}>
            <HiOutlineMail /> Say hello
            <HiOutlineArrowRight />
          </a>

          <div className="contact__links">
            <a href={`mailto:${profile.email}`} className="contact__link">
              <span className="contact__link-label">Email</span>
              <span className="contact__link-value">{profile.email}</span>
            </a>
            <a href={profile.linkedin} target="_blank" rel="noreferrer" className="contact__link">
              <span className="contact__link-label">LinkedIn</span>
              <span className="contact__link-value">/in/sushan-k</span>
            </a>
            <a href={profile.github} target="_blank" rel="noreferrer" className="contact__link">
              <span className="contact__link-label">GitHub</span>
              <span className="contact__link-value">/sushan</span>
            </a>
          </div>

          <div className="contact__socials">
            <a href={`mailto:${profile.email}`} aria-label="Email"><HiOutlineMail /></a>
            <a href={profile.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn"><FiLinkedin /></a>
            <a href={profile.github} target="_blank" rel="noreferrer" aria-label="GitHub"><FiGithub /></a>
          </div>
        </Reveal>

        <div className="contact__bar">
          <span className="contact__copy">
            © {year} {profile.name}. Built with React & care.
          </span>
          <a href="#home" className="contact__top">
            Back to top ↑
          </a>
        </div>
      </div>
    </footer>
  );
}
